import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { map, tap, catchError } from 'rxjs/operators';
import { ToastProvider } from '@core';
import { InvestigationsRepository } from '../../../infrastructure/repositories/investigations.repository';

export interface ConvertToInvestigationCommand {
  readonly investigationId: string;
  readonly conversionReasonId: string;
  readonly conversionNotes: string;
}

export interface ConvertToInvestigationResult {
  readonly success: boolean;
  readonly investigationId: string;
}

@Injectable({ providedIn: 'root' })
export class ConvertToInvestigationUseCase {
  private readonly _repository = inject(InvestigationsRepository);
  private readonly _toast = inject(ToastProvider);

  public execute(command: ConvertToInvestigationCommand): Observable<ConvertToInvestigationResult> {
    return this._repository
      .convertToInvestigation(command.investigationId, command.conversionReasonId, command.conversionNotes)
      .pipe(
        tap(() => {
          this._toast.success('Converted to Investigation', 'The case has been converted to a formal investigation.');
        }),
        map(() => ({ success: true, investigationId: command.investigationId })),
        catchError((error) => {
          this._toast.error('Conversion failed', 'Please try again or contact support.');
          return throwError(() => error);
        }),
      );
  }
}
